class CartWatcher {

    init() {
      this.emitCartChanges().then(() => {
        this.observeCartChanges();
       
      });
    }
  
    async fetchCart() {
      const response = await fetch('/cart.js');

      return response.json();
    }
  
    storeCart(cart) {
      localStorage.setItem('cart', JSON.stringify(cart));
    }
  
   storedCart() {
      
      
        
      return JSON.parse(localStorage.getItem('cart')) || { items: [] };
    }
  
   findCartChanges(oldCart, newCart) {
      const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
      let result = {
        added: onlyInLeft(newCart.items, oldCart.items),
        removed: onlyInLeft(oldCart.items, newCart.items),
      };
  
      oldCart.items.forEach(oi => {
        const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
        if (!ni) return;
        let quantity = ni.quantity - oi.quantity;
        let item = { ...ni };
        item.quantity = Math.abs(quantity);
        quantity > 0
          ? result.added.push(item)
          : result.removed.push(item)
      });
  
      return result;
    }
  
    async emitCartChanges() {
      const newCart = await this.fetchCart();
      const oldCart = this.storedCart();
      const changes = this.findCartChanges(oldCart, newCart);
  
      const event = new CustomEvent("cart_changed", { detail: changes });
      window.dispatchEvent(event);
  
      this.storeCart(newCart);
      //console.log("here new cart:",newCart )

    //   avalidation new items

      var cart_items = newCart
      const shippingElement = document.querySelector(".minicart__subtotal-value.shipping_price"); 

      const customizerData = JSON.parse(
        document.getElementById("minicart-customizer-data").textContent
      );

      const thresholdResult = 150;

      const shippingThreshold = customizerData.customizer.shipping_threshold;

      if (shippingThreshold && shippingThreshold > 0 && shippingThreshold != '' && shippingThreshold != null) {
        thresholdResult = parseInt(shippingThreshold);
      }
      
      if (cart_items.items_subtotal_price >= thresholdResult * 100){
      
        if (shippingElement) {
            shippingElement.textContent = "Free";
        }
      }else{
        if (shippingElement) {
            shippingElement.textContent = "$10";
        }
      }
      const hasOnlyRoaringJournals = cart_items.items.every(item => 
            item.title.includes("Roaring Journals Print Edition")
        );
    
        if (hasOnlyRoaringJournals) {
            //console.log("here only RJ")
            // Update the shipping price to "Free"
            const shippingElement = document.querySelector(".minicart__subtotal-value.shipping_price"); // Update selector accordingly
            if (shippingElement) {
                shippingElement.textContent = "Free";
            }
        }


    }
  
   observeCartChanges() {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            this.emitCartChanges();
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    }
  }
    const myCartWatcher = new CartWatcher();
    myCartWatcher.init();

    window.addEventListener("cart_changed", (cart) => {
        //console.log(cart.detail);
       
    });


   